import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IConfigProductHierarchyResponseModel } from '../interfaces/config-product-hierarchy-response.model';
import { ProductLevel } from '../interfaces/product-level.enum';

@Injectable({
    providedIn: 'root'
})
export class ProductHierarchyService {
    private readonly _cache: Map<ProductLevel, Array<IConfigProductHierarchyResponseModel>> = new Map<
        ProductLevel,
        Array<IConfigProductHierarchyResponseModel>
    >();

    public constructor(private readonly _http: HttpClient) {}

    public async getAttributeValues(productLevel: ProductLevel): Promise<Array<IConfigProductHierarchyResponseModel>> {
        // Check cache first
        const cachedData: Array<IConfigProductHierarchyResponseModel> | undefined = this._cache.get(productLevel);
        if (cachedData) {
            return cachedData;
        }

        // If not in cache, fetch from API
        const data: Array<IConfigProductHierarchyResponseModel> = await firstValueFrom<
            Array<IConfigProductHierarchyResponseModel>
        >(
            this._http.get<Array<IConfigProductHierarchyResponseModel>>(
                `${environment.apiUrl}/api/config-product-hierarchy/getAll/${productLevel}`
            )
        );

        // Store in cache
        this._cache.set(productLevel, data);

        return data;
    }

    public clearCache(productLevel?: ProductLevel): void {
        if (productLevel) {
            this._cache.delete(productLevel);
        } else {
            this._cache.clear();
        }
    }
}
